import { FC } from 'react';

import Badge from '@mui/material/Badge/Badge';
import Button from '@mui/material/Button/Button';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import { GridApiPro } from '@mui/x-data-grid-pro';

import Action from '../types/action.type';

type DefaultButtonProps = Extract<Action, { type: 'default' }> & {
  apiRef: React.MutableRefObject<GridApiPro>;
};

const DefaultButton: FC<DefaultButtonProps> = ({
  button,
  badgeProps,
  tooltipProps,
  apiRef,
}) => {
  return (
    <Tooltip title={tooltipProps?.title} {...tooltipProps}>
      <Badge {...badgeProps}>
        <Button {...button} onClick={() => button.onClick?.(apiRef)}>
          {button.label}
        </Button>
      </Badge>
    </Tooltip>
  );
};

export default DefaultButton;
